// eslint-disable-next-line import/no-cycle
import { X_UAR_HTTP_HEADERS } from '@upstart/harmony/lib/legos/constants/system';
import store from '../redux/store';
import { getDeal } from '../redux/deals/selectors';

export default function getDealIdHeader() {
  const deal = getDeal(store.getState());
  return deal?.id ? { [X_UAR_HTTP_HEADERS['X-UAR-DealId']]: deal.id } : {};
}
